/**
 * Query keys for the per-loan lists, in one place because they invalidate each
 * other: an upload from Tasks lands in the Docs list, and deleting a document from
 * Docs reopens the task it satisfied (the API archives with
 * `ReopenAssociatedDocumentRequiredTasks`). Keeping them in their own hooks made
 * `useDocs` and `useTasks` import each other.
 */

export const docsQueryKey = (loanId: string) => ['loan', loanId, 'docs'] as const;

export const tasksQueryKey = (loanId: string) => ['loan', loanId, 'tasks'] as const;
